import { useState } from "react";
import { VIDEOS } from "@/data";

export default function Videos() {
  const [playing, setPlaying] = useState(null);

  return (
    <div data-testid="videos-list" className="max-w-3xl mx-auto flex flex-col gap-8 sm:gap-10">
      {VIDEOS.map((v, i) => (
        <div key={v.id} className="relative w-full aspect-video bg-[#0a0a0a]" data-testid={`video-${i}`}>
          {playing === v.id ? (
            <iframe data-testid={`video-player-${i}`} title={v.title} className="absolute inset-0 w-full h-full"
              src={`https://www.youtube.com/embed/${v.id}?autoplay=1&rel=0&modestbranding=1`}
              frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
          ) : (
            <button onClick={() => setPlaying(v.id)} data-testid={`video-play-${i}`} className="group absolute inset-0 w-full h-full text-left">
              <img src={`https://i.ytimg.com/vi/${v.id}/hqdefault.jpg`} alt={v.title}
                className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-[filter] duration-700" />
              <span className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-black/80 to-transparent" />
              <span className="absolute left-4 bottom-4 text-lg sm:text-xl tracking-wide text-[#e6e8eb]">{v.title}</span>
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
